import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
import { WHATSAPP_NUMBER } from '../lib/constants';
export function ContactForm() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    email: '',
    tipoPlaga: '',
    metrosCuadrados: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.nombre || !formData.telefono || !formData.email) return;
    let text = `Hola Mobal, soy ${formData.nombre}. Necesito un presupuesto.\n\n`;
    text += `*Teléfono:* ${formData.telefono}\n`;
    text += `*Email:* ${formData.email}\n`;
    if (formData.tipoPlaga) {
      text += `*Tipo de plaga:* ${formData.tipoPlaga}\n`;
    }
    if (formData.metrosCuadrados) {
      text += `*Metros cuadrados:* ${formData.metrosCuadrados} m2\n`;
    }
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
    window.open(whatsappUrl, '_blank');
  };
  return <section className="bg-gray-100 py-20" id="formulario" data-id="element-72">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="max-w-3xl mx-auto bg-mobal-white rounded-2xl shadow-xl overflow-hidden" data-id="element-74">
          <div className="bg-mobal-black p-8 md:p-10 text-center" data-id="element-75">
            <h2 className="text-3xl md:text-4xl font-heading font-black text-mobal-white mb-2" data-id="element-76">
              Contáctanos
            </h2>
            <p className="text-mobal-green font-body" data-id="element-77">
              Completa el formulario y te respondemos por WhatsApp
            </p>
          </div>

          <div className="p-8 md:p-10" data-id="element-78">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-79">
              <div data-id="element-80">
                <label htmlFor="nombre" className="block text-sm font-bold text-mobal-black mb-2 uppercase" data-id="element-81">
                  Nombre *
                </label>
                <input type="text" id="nombre" name="nombre" required value={formData.nombre} onChange={handleChange} className="w-full px-4 py-3 rounded-md border border-gray-300 focus:border-mobal-black focus:ring-2 focus:ring-mobal-black/20 outline-none transition-all bg-gray-50 text-mobal-black" placeholder="Tu nombre completo" data-id="element-82" />
              </div>

              <div data-id="element-83">
                <label htmlFor="telefono" className="block text-sm font-bold text-mobal-black mb-2 uppercase" data-id="element-84">
                  Teléfono *
                </label>
                <input type="tel" id="telefono" name="telefono" required value={formData.telefono} onChange={handleChange} className="w-full px-4 py-3 rounded-md border border-gray-300 focus:border-mobal-black focus:ring-2 focus:ring-mobal-black/20 outline-none transition-all bg-gray-50 text-mobal-black" placeholder="Tu número de teléfono" data-id="element-85" />
              </div>

              <div data-id="element-86">
                <label htmlFor="email" className="block text-sm font-bold text-mobal-black mb-2 uppercase" data-id="element-87">
                  Email *
                </label>
                <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-md border border-gray-300 focus:border-mobal-black focus:ring-2 focus:ring-mobal-black/20 outline-none transition-all bg-gray-50 text-mobal-black" placeholder="tu@email.com" data-id="element-88" />
              </div>

              <div data-id="element-89">
                <label htmlFor="tipoPlaga" className="block text-sm font-bold text-mobal-black mb-2 uppercase" data-id="element-90">
                  Tipo de plaga
                </label>
                <select id="tipoPlaga" name="tipoPlaga" value={formData.tipoPlaga} onChange={handleChange} className="w-full px-4 py-3 rounded-md border border-gray-300 focus:border-mobal-black focus:ring-2 focus:ring-mobal-black/20 outline-none transition-all bg-gray-50 text-mobal-black appearance-none" data-id="element-91">
                  <option value="" disabled data-id="element-92">
                    Seleccioná una opción
                  </option>
                  <option value="Cucarachas" data-id="element-93">Cucarachas</option>
                  <option value="Alacranes" data-id="element-94">Alacranes</option>
                  <option value="Hormigas" data-id="element-95">Hormigas</option>
                  <option value="Ratas" data-id="element-96">Ratas</option>
                  <option value="Otros" data-id="element-97">Otros</option>
                </select>
              </div>

              <div data-id="element-98">
                <label htmlFor="metrosCuadrados" className="block text-sm font-bold text-mobal-black mb-2 uppercase" data-id="element-99">
                  Metros cuadrados
                </label>
                <input type="number" id="metrosCuadrados" name="metrosCuadrados" value={formData.metrosCuadrados} onChange={handleChange} min="0" className="w-full px-4 py-3 rounded-md border border-gray-300 focus:border-mobal-black focus:ring-2 focus:ring-mobal-black/20 outline-none transition-all bg-gray-50 text-mobal-black" placeholder="Ej: 120" data-id="element-100" />
              </div>

              <button type="submit" className="w-full flex items-center justify-center gap-2 bg-mobal-green text-mobal-black font-bold py-4 px-8 rounded-md hover:bg-[#b5ff33] transition-colors min-h-[56px] text-lg mt-4" data-id="element-101">
                Enviar
              </button>
            </form>

            <div className="mt-8 pt-6 border-t border-gray-200 text-center" data-id="element-102">
              <a href="mailto:mobalfumigaciones@gmail.com" className="inline-flex items-center gap-2 text-gray-600 hover:text-mobal-black transition-colors font-medium" data-id="element-103">
                <Mail className="w-5 h-5" data-id="element-104" />O escribinos directamente a
                mobalfumigaciones@gmail.com
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}